<app-header></app-header>

<router-outlet></router-outlet>
<app-footer></app-footer>

<a class="app-whatsapp" href="https://api.whatsapp.com/send?phone=+5493884580977&text=
Hola SINIDE-SGE, me llamo ......., de la escuela .......  y  quiero consultar sobre: ...." target="_blanck">
    <img class="imagen" src="assets/images/whatsapp.png" alt="WhatsApp">
  </a>
